export const textPresetKeys = [
	'Title',
	'Menu',
	'Page-title',
	'Heading-XL',
	'Heading-L',
	'Heading-M',
	'Heading-S',
	'Body-L',
	'Body-M',
	'Body-S',
	'Body-XS',
]
